<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const knowledgeSystemUrl = useMapGetter('globalConfig/knowledgeSystemUrl');

const iframeSrc = computed(() => {
  return knowledgeSystemUrl.value || '';
});
</script>

<template>
  <div class="flex flex-col h-full w-full">
    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      class="flex-1 w-full h-full border-0"
      :title="$t('KNOWLEDGE_PAGE.IFRAME_TITLE')"
      sandbox="allow-downloads allow-scripts allow-same-origin allow-forms allow-popups"
      allow="clipboard-read; clipboard-write"
      loading="lazy"
    />
    <div v-else class="flex items-center justify-center h-full text-n-slate-11">
      <p>{{ $t('KNOWLEDGE_PAGE.NOT_CONFIGURED') }}</p>
    </div>
  </div>
</template>
